import React, { useEffect, useState } from "react";
import styles from "./home.module.scss";
// import { useIntl, history, useModel } from 'umi';
import Layout from "../../layouts/User";
import Provision from "../../layouts/User/provision";
import { ONETRUST_TERMS_OF_USE_URL } from "../../config";
import axios from "axios";

export type Props = {};

const breadcrumbs = [
  {
    text: "หน้าแรก",
    path: "/",
  },
  {
    text: "ข้อกำหนดและเงื่อนไข",
  },
];
const TermsOfUse: React.FC<Props> = (props) => {
  const [notices, setNotices] = useState<any>();
  const [term, setTerm] = useState<any>();

  const getTerm = async () => {
    const allOrder = await axios.get(`/term-of-use/role?role=buyer`);
    setTerm(htmlDecode(allOrder.data.termOfUse));
  };
  const htmlDecode = (content: any) => {
    let e = document.createElement("div");
    e.innerHTML = content;
    return e.childNodes.length === 0 ? "" : e.childNodes[0].nodeValue;
  };
  useEffect(() => {
    getTerm();
    let script3 = document.createElement("script");
    script3.setAttribute(
      "src",
      "https://privacyportal-apac-cdn.onetrust.com/privacy-notice-scripts/otnotice-1.0.min.js"
    );
    script3.setAttribute("type", "text/javascript");
    script3.setAttribute("charset", "UTF-8");
    script3.setAttribute("id", "otprivacy-notice-script");
    script3.async = true;
    script3.innerHTML = `settings="eyJjYWxsYmFja1VybCI6Imh0dHBzOi8vcHJpdmFjeXBvcnRhbC1hcGFjLm9uZXRydXN0LmNvbS9yZXF1ZXN0L3YxL3ByaXZhY3lOb3RpY2VzL3N0YXRzL3ZpZXdzIn0="`;
    document.head.appendChild(script3);
    // **** UAT START ****
    // const ONETRUST_TERMS_OF_USE = `https://privacyportal-uat-cdn.onetrust.com/669247f0-b028-4f7e-a819-5e780546ba06/privacy-notices/draft/c8f82f23-04c7-4ab9-9b97-ffc362d5c1d3-th-th.json`;
    // **** UAT END ****
    // **** PRODUCTION START ****
    // const ONETRUST_TERMS_OF_USE = `https://privacyportal-uat-cdn.onetrust.com/669247f0-b028-4f7e-a819-5e780546ba06/privacy-notices/draft/c8f82f23-04c7-4ab9-9b97-ffc362d5c1d3-th-th.json`;
    // **** PRODUCTION END ****
    const ONETRUST_TERMS_OF_USE = `${ONETRUST_TERMS_OF_USE_URL}`;
    fetch(ONETRUST_TERMS_OF_USE)
      .then((response) => response.json())
      .then((jsonData) => {
        // jsonData is parsed json object received from url
        const aaaa = jsonData.notices[Object.keys(jsonData.notices)[0]];

        setNotices(aaaa.content);
      })
      .catch((error) => {
        // handle your errors here
        console.error(error);
      });
  }, []);
  return (
    <>
      <Layout breadcrumbItems={breadcrumbs} breadcrumbMarginBottom={50}>
        <div className={styles.wrapper}>
          <div className={styles.topBody} style={{ marginTop: 70 }}></div>
        </div>
        <div
          className="otnotice"
          dangerouslySetInnerHTML={{
            __html: term ? term : "",
          }}
        ></div>
      </Layout>
    </>
  );
};
export default TermsOfUse;
